import { defineMessages } from 'react-intl';

export default defineMessages({
  copied: 'Copied',
  copy: 'Copy to clipboard',
});
